import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Box from '@mui/material/Box';

import { SxProps, Theme } from '@mui/material/styles';
import { FlightListProvider_flight$key } from '__generated__/FlightListProvider_flight.graphql';

import WAAVO from 'assets/integration-icons/waavo.png';
import KIWI from 'assets/integration-icons/kiwi.png';

type Props = {
  flight: FlightListProvider_flight$key;
  sx?: SxProps<Theme>;
};

const providerIcons = { WAAVO, KIWI };

const FlightListProvider: FC<Props> = ({ flight, sx }) => {
  const { provider } = useFragment(
    graphql`
      fragment FlightListProvider_flight on Flight {
        provider
      }
    `,
    flight
  );

  return (
    <Box sx={sx}>
      <img
        src={providerIcons[provider]}
        alt={provider}
        style={{ height: '100%' }}
      />
    </Box>
  );
};

export default FlightListProvider;
